
import { mapState } from 'vuex';
import SizeRecommendationMobile from './components/SizeRecommendationMobile';
import SizeRecommendationPc from './components/SizeRecommendationPc';

export default {
  i18nComponentKey: 'WidgetAddOnSizeRecommendation.WidgetAddOnSizeRecommendation',
  name: 'WidgetAddOnSizeRecommendation',
  components: { SizeRecommendationMobile, SizeRecommendationPc },
  computed: {
    ...mapState('widget', ['isMobile']),
    ...mapState('reviewSettings', ['reviewSettings']),
    rootStyle() {
      const {
        ai_size_recommendation_highlight_color: highlightColor,
        main_color: mainColor
      } = this.reviewSettings;
      const backgroundColor = this.applyOpacityToHex(mainColor, 0.08);

      return {
        '--ai-size-recommendation-highlight-color': highlightColor,
        '--ai-size-recommendation-highlight-background-color': backgroundColor
      };
    }
  },
  methods: {
    applyOpacityToHex(hexColor, opacity) {
      const alpha = Math.round(opacity * 255)
        .toString(16)
        .padStart(2, '0');

      return `${hexColor}${alpha}`;
    }
  }
};
